export interface PocBasicTreeNode {
  key: string;
  title: string;
}

export enum PocNodeType {
  User = 'user',
  Group = 'group',
  PlaceHolder = 'placeholder',
}

export interface UserNode extends PocBasicTreeNode {
  checked: boolean;
  type: PocNodeType.User;
  children: null;
  target: object;
}

export interface GroupNode extends PocBasicTreeNode {
  expanded: boolean;
  type: PocNodeType.Group;
  children: UserNode[];
}

export interface PlaceHolderNode extends PocBasicTreeNode {
  expanded: boolean;
  type: PocNodeType.PlaceHolder;
  // if UserNode, maybe just one item, [UserNode]
  children: (UserNode | GroupNode)[];
}

export type TreeNodeInstance = UserNode | GroupNode | PlaceHolderNode;

export enum PocTargetSearchType {
  TargetUser = 'targetUser',
  TargetGroup = 'targetGroup',
}

export interface TargetNode extends PocBasicTreeNode {
  target: object;
}
